module.exports = __webpack_public_path__ + "static/media/bg-calculadora-card.a6659ce7.png";